import {axios} from "./config"
export class Role extends axios{
   axios;
   token;
   constructor(){
   super();
   this.axios=this.axiosConfig();
 }
 async add(data){
   
    try{
    let result=await this.axios({
    method:"post",
    url:"role",
    data
    
});
    return new Promise((res,rej)=>{
        res(result.data);
    })
    }catch(e){
        return new Promise((res,rej)=>{
            rej(e);
        })
      
    }
}
async update(data){
   
    try{
    let result=await this.axios({
    method:"patch",
    url:"role",
    data
    
});
    return new Promise((res,rej)=>{
        res(result.data);
    })
    }catch(e){
        return new Promise((res,rej)=>{
            rej(e);
        })
      
    }
}
async delete(data){
   
    try{
    let result=await this.axios({
    method:"delete",
    url:"role",
    data
    
});
    return new Promise((res,rej)=>{
        res(result.data);
    })
    }catch(e){
        return new Promise((res,rej)=>{
            rej(e);
        })
      
    }
}
 async get(){
   
        try{
        let result=await this.axios({
        method:"get",
        url:"role",
        
    });
        return new Promise((res,rej)=>{
            res(result.data);
        })
        }catch(e){
            return new Promise((res,rej)=>{
                rej(e);
            })
          
        }
}
         
                                                          
        
}